module.exports = __webpack_public_path__ + "static/media/diaphragm.f6204831.svg";